module.exports = require('./src/vue-timepicker.vue')



//////////////////
// WEBPACK FOOTER
// ./~/vue2-timepicker/index.js
// module id = SVjV
// module chunks = 1